import { HomeStoreProvider, useHomeStore } from '../../stores/home-store';
import HomeToolbar from './toolbar/home-toolbar';
import OperationalView from './operational-view/operational-view';
import BiView from './bi-view/bi-view';
import './home.scss';

function HomeContent() {
  const [selectedView] = useHomeStore(store => store.selectedView);

  return (
    <div className="home-page d-flex flex-column">
      <HomeToolbar />
      <div className="home-page-content">
        {selectedView === 'bi' ? <BiView /> : <OperationalView />}
      </div>
    </div>
  );
}

export default function Home() {
  return (
    <HomeStoreProvider>
      <HomeContent />
    </HomeStoreProvider>
  );
}
